(() => {
  const root = document.querySelector('[data-clearance-delivery]');
  if (!root) return;

  const titleEl = root.querySelector('[data-clearance-title]');
  const noteEl = root.querySelector('[data-clearance-note]');
  if (!titleEl) return;

  const cutoffHour = Number(root.dataset.cutoffHour || 12);
  const deliveryDays = Number(root.dataset.deliveryDays || 2);
  const timeZone = root.dataset.timezone || 'Asia/Kolkata';
  const holidays = new Set(
    (root.dataset.holidays || '')
      .split(',')
      .map((d) => d.trim())
      .filter(Boolean)
  );

  const weekdayFmt = new Intl.DateTimeFormat('en-IN', {
    timeZone,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });

  const partsFmt = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  function getZonedParts(date) {
    const parts = Object.fromEntries(
      partsFmt.formatToParts(date).map((p) => [p.type, p.value])
    );
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second),
    };
  }

  function toKey(y, m, d) {
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }

  /** Noon IST as a UTC Date for a given local Y-M-D */
  function zonedDate(y, m, d, hour = 0, minute = 0, second = 0) {
    // IST is UTC+5:30 with no DST
    const utcMs = Date.UTC(y, m - 1, d, hour, minute, second) - (5.5 * 60 * 60 * 1000);
    return new Date(utcMs);
  }

  function addDays(y, m, d, n) {
    const dt = zonedDate(y, m, d, 12);
    dt.setUTCDate(dt.getUTCDate() + n);
    const p = getZonedParts(dt);
    return { year: p.year, month: p.month, day: p.day };
  }

  function isNonWorking(y, m, d) {
    const key = toKey(y, m, d);
    if (holidays.has(key)) return true;
    // Sunday = 0 in local IST
    const weekday = new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'short',
    }).format(zonedDate(y, m, d, 12));
    return weekday === 'Sun';
  }

  function nextWorkingDay(y, m, d) {
    let cur = { year: y, month: m, day: d };
    while (isNonWorking(cur.year, cur.month, cur.day)) {
      cur = addDays(cur.year, cur.month, cur.day, 1);
    }
    return cur;
  }

  function addWorkingDays(start, days) {
    let cur = { ...start };
    let left = days;
    while (left > 0) {
      cur = addDays(cur.year, cur.month, cur.day, 1);
      if (!isNonWorking(cur.year, cur.month, cur.day)) left -= 1;
    }
    return cur;
  }

  function msUntilCutoff(now, parts) {
    const cutoff = zonedDate(parts.year, parts.month, parts.day, cutoffHour, 0, 0);
    return cutoff.getTime() - now.getTime();
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '';
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const pad = (n) => String(n).padStart(2, '0');
    if (h > 0) return `${h}h ${pad(m)}m ${pad(s)}s`;
    return `${m}m ${pad(s)}s`;
  }

  function formatDate(y, m, d) {
    return weekdayFmt.format(zonedDate(y, m, d, 12));
  }

  function render() {
    const now = new Date();
    const parts = getZonedParts(now);
    const beforeCutoff = parts.hour < cutoffHour;

    let start = {
      year: parts.year,
      month: parts.month,
      day: parts.day,
    };

    if (!beforeCutoff) {
      start = addDays(start.year, start.month, start.day, 1);
    }

    start = nextWorkingDay(start.year, start.month, start.day);
    const delivery = addWorkingDays(start, deliveryDays);
    const deliveryLabel = formatDate(delivery.year, delivery.month, delivery.day);

    if (beforeCutoff) {
      const left = formatCountdown(msUntilCutoff(now, parts));
      titleEl.innerHTML = left
        ? `Order within <strong>${left}</strong> (before 12:00 PM) to get it by <strong>${deliveryLabel}</strong>`
        : `Order before <strong>12:00 PM</strong> to get it by <strong>${deliveryLabel}</strong>`;
      if (noteEl) {
        noteEl.textContent =
          'Clearance items: 2-day delivery when ordered before noon. Sundays & holidays extend by a day.';
      }
    } else {
      titleEl.innerHTML = `Order now to get it by <strong>${deliveryLabel}</strong>`;
      if (noteEl) {
        noteEl.textContent =
          'Orders after 12:00 PM start next working day. Sundays & holidays extend the timeline by a day.';
      }
    }
  }

  render();
  setInterval(render, 1000);
})();
